module.exports = __webpack_public_path__ + "static/media/logo-8V.5fec82e7.png";